import React, { useEffect, useState } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth"
import auth, { db } from "../config/firebase";
import { arrayUnion, doc, query, collection, getDocs, where, updateDoc } from "firebase/firestore";
import { NavDropdown } from 'react-bootstrap';
import "./Mart.css";

const Mart = () => {

    const [user, loading, error] = useAuthState(auth);
    const [name, setName] = useState("");
    const [balance, setBalance] = useState("");
    const [items, setItems] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [rerender, setRerender] = useState();
    const navigate = useNavigate();

    let itemed = false;

    const cart = async () => {
        try {
            const q = query(collection(db, "users"), where("uid", "==", user?.uid));
            const doc = await getDocs(q);
            const data = doc.docs[0].data();
            const items = await data.cartitems.map(async (id) => {
                const q = query(collection(db, "items"), where("id", "==", id));
                const doc = await getDocs(q)
                    .then((d) => d.docs[0].data().name);
                return doc;
            });
            Promise.all(items).then((values) => console.log(values));
        } catch (err) {
            console.error(err);
            alert("An error occurred while fetching cart data");
        }
    }

    const fetchUserName = async () => {
        try {
            const q = query(collection(db, "users"), where("uid", "==", user?.uid));
            const doc = await getDocs(q);
            const data = doc.docs[0].data();
            setName(data.name);
            setBalance(data.balance);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchItems = async() => {
        try {
            await getDocs(collection(db, "items"))
                .then((querySnapshot) => {
                    const newData = querySnapshot.docs
                        .map((doc) => ({...doc.data()}));
                    setItems(() => {
                        return newData;
                    });
                    // .map((item) => <Item i={item} key={item.id} />)
                });
            setLoaded(true);
        } catch (err) {
            console.error(err);
            alert("An error occurred while fetching items");
        }

    }

    const logOut = async () => {
        try {
            await signOut(auth);
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    }

    const addToCart = async (id) => {
        const docRef = doc(db, "users", user.uid);
        await updateDoc(docRef, {
            cartitems: arrayUnion(id)
        });
        alert("Item added to cart.");
    };

    useEffect(() => {
        if (loading) return <div>Loading...</div>;
        if (!user) return navigate("/");
        fetchUserName();
        if (!loaded) fetchItems();
    }, [user, loading]);

    useEffect(() => {
        setRerender(Symbol());
    }, [items.length]);

    return (
        <div id="mart">
            <div className="mart__header">
                <p className="mart__top">
                    <h1>Welcome to the Mart!</h1> 
                    <h2>{name} | Balance: {balance} </h2> 
                    <button className="mart__btn" onClick={cart}>Cart</button>
                    <button className="mart__btn" onClick={logOut}>Log Out</button>
                </p>
            </div>
            <div className="mart__items">
                {items.map(i =>{
                    console.log(i.name);
                    return (
                        <div className="mart__item" key={i.id}>
                            <img className="mart__item__image" src={i.image} />
                            <div className="mart__item__div__left">
                                <h2>{i.name}</h2>
                                <p>{i.description}</p>
                            </div>
                            <div className="mart_item__div__right">
                                <h1 style={{align:'right'}}>${i.price}</h1>
                                <button className="mart__item__btn" onClick={()=>addToCart(i.id)}>Add to Cart</button>
                            </div>
                        </div>
                    );
                })}
            </div>
            
        </div>
    );
};

export default Mart;

